import Loc from "../../../Loc/Loc";
import "./Report.css";

export default function Report () {
    return (
        <div>
            <hr></hr>
            <footer className="Report">
                <p>{Loc.trad().ReportTitle}</p>
                <span>
                    <a className="btn btn-info"
                        href="mailto:fivesnordon.support.portail.documentaire@fivesgroup.com?Subject=Support%20Portail%20Documentaire%20">
                        {Loc.trad().ReportProblem}
                    </a>
                </span>
            </footer>
        </div>
    )
}